import { ReactNode, useState } from 'react'

import Dialog from '@mui/material/Dialog'

const useDialog = () => {
  const [open, setOpen] = useState(false)
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const render = (children: ReactNode) => {
    return (
      <Dialog open={open} onClose={handleClose}>
        {children}
      </Dialog>
    )
  }
  return { openDialog: handleOpen, closeDialog: handleClose, open, render }
}

export default useDialog
